"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecificSearchSelectField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const SpecificSearchSelect_1 = require("@src/components/modules/SpecificSearchSelect/SpecificSearchSelect");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const SpecificSearchSelectWrapper_1 = require("@src/components/modules/SpecificSearchSelect/SpecificSearchSelectWrapper");
const SpecificSearchSelectField = ({ name, rules, formValues, setFormValues, }) => {
    const intl = (0, react_intl_1.useIntl)();
    const setSelectedValues = (newSpecificSearchValues) => {
        const newFormValues = {
            ...formValues,
            [name]: newSpecificSearchValues,
        };
        // @ts-ignore
        setFormValues(newFormValues);
    };
    const isTagCountInLimit = Boolean(formValues.specificSearch && formValues.specificSearch.length < SpecificSearchSelect_1.tagOptions.maxTagCount);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'global.specific_search.title',
                }), rules: rules, name: name, className: isTagCountInLimit ? '' : 'm-b-s', children: (0, jsx_runtime_1.jsx)(SpecificSearchSelectWrapper_1.SpecificSearchSelectWrapper, { isTagCountInLimit: isTagCountInLimit, selectedValues: formValues.specificSearch, setSelectedValues: setSelectedValues }) }), !isTagCountInLimit && ((0, jsx_runtime_1.jsx)(elements_1.Alert, { className: "m-b-m", message: intl.formatMessage({ id: 'offers.max_tag_count_alert' }), type: "warning", showIcon: true }))] }));
};
exports.SpecificSearchSelectField = SpecificSearchSelectField;
